import { lazy, Suspense } from 'react';
import { ThLoading } from '@components/elements';
import { UserRole } from '@constants/userRoles';
import { useUserContext } from '@state/userContext';
import AuthFailedModal from '@components/elements/AuthFailedModal';
import LoginRedirect from '@components/elements/LoginRedirect/LoginRedirect';
import { isDev } from '@utils/Environment';

// Eager imports for dev (ensures correct CSS order)
// Lazy imports for production (code splitting: worker vs company)
import CompanyAppShellEager from './CompanyAppShell';
import WorkerAppShellEager from './WorkerAppShell';

const CompanyAppShellLazy = lazy(() => import('./CompanyAppShell'));
const WorkerAppShellLazy = lazy(() => import('./WorkerAppShell'));

function renderAppShell(isCompany: boolean) {
  if (isDev()) {
    return isCompany ? <CompanyAppShellEager /> : <WorkerAppShellEager />;
  }
  return (
    <Suspense fallback={<ThLoading />}>
      {isCompany ? <CompanyAppShellLazy /> : <WorkerAppShellLazy />}
    </Suspense>
  );
}

export default function AppRoutes() {
  const { hasRole, isLoading } = useUserContext();

  if (isLoading) {
    return <ThLoading />;
  }

  const isCompany = hasRole(UserRole.ROLE_COMPANY);

  if (!isCompany && !hasRole(UserRole.ROLE_USER)) {
    return <LoginRedirect />;
  }

  return (
    <>
      <AuthFailedModal />
      {renderAppShell(isCompany)}
    </>
  );
}
